import styled from 'styled-components';

export const ButtonContainer = styled.a`
  border: 1px solid ${props => props.borderColor};
`;
